interface Props {
  color?: string
  width?: number
  height?: number
}

export const EditIcon = ({ color = '#6F6F6F', width = 21, height = 21 }: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20.4971 19.9977C20.7732 19.9977 20.9971 20.2216 20.9971 20.4977C20.997 20.7738 20.7732 20.9977 20.4971 20.9977H0.501953C0.226079 20.9975 0.00203956 20.7737 0.00195312 20.4977C0.00195312 20.2218 0.226026 19.998 0.501953 19.9977H20.4971ZM13.1572 0.857117C13.743 0.270886 14.6934 0.271065 15.2793 0.857117L17.9229 3.50165C18.5078 4.08728 18.5078 5.03614 17.9229 5.62177L7.43457 16.1149C7.15328 16.3962 6.77083 16.5544 6.37305 16.5544H3.72363C2.94722 16.5541 2.30828 15.9639 2.23145 15.2077L2.22363 15.0544V12.4245C2.2237 12.0273 2.3816 11.6461 2.66211 11.3649L13.1572 0.857117ZM14.5723 1.56415C14.3769 1.36886 14.0595 1.3687 13.8643 1.56415L3.37012 12.071C3.27675 12.1646 3.2237 12.2922 3.22363 12.4245V15.0544L3.2334 15.155C3.27992 15.3828 3.48215 15.5542 3.72363 15.5544H6.37305C6.50542 15.5544 6.63284 15.5013 6.72656 15.4079L17.2148 4.91473C17.4099 4.71951 17.4099 4.40391 17.2148 4.20868L14.5723 1.56415Z"
        fill={color}
      />
    </svg>
  )
}
